import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Thumbnail } from '../Thumbnail';
import { useThumbnailLocationListener } from '@state';
import { useDynamicMaxHeight } from '../../hooks/useDynamicMaxHeight';
import { ScrollArea } from '../ScrollArea';
import {
  LeftOutlined,RightOutlined
} from '@ant-design/icons';

const ThumbnailList = ({
  servicesManager,
  thumbnails,
  onThumbnailClick,
  onThumbnailDoubleClick,
  onClickUntrack,
  activeDisplaySetInstanceUIDs = [],
  viewPreset,
  ThumbnailMenuItems,
}) => {
  // Use the dynamic height hook on the parent container
  const { ref, maxHeight } = useDynamicMaxHeight(thumbnails);
  const scrollContainerRef_thumnailList = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(true);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  // Filter thumbnails into list items and thumbnail items
  const listItems = thumbnails?.filter(
    ({ componentType }) => componentType === 'thumbnailNoImage' || viewPreset === 'list'
  );

  const thumbnailItems = thumbnails?.filter(
    ({ componentType }) => componentType !== 'thumbnailNoImage' && viewPreset === 'thumbnails'
  );

  const thumbnailLocation = useThumbnailLocationListener();

  const handleScroll = () => {
    const scrollContainer = scrollContainerRef_thumnailList.current;
    if (!scrollContainer) {
      return;
    }
    const { scrollWidth, clientWidth, scrollLeft } = scrollContainer;
    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 6);
  };

  const onLoadComplete = () => {
    setIsLoaded(true);
  }

  useEffect(() => {
    const scrollContainer = scrollContainerRef_thumnailList.current;
    if (scrollContainer) {
      handleScroll();
      scrollContainer.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('resize', handleScroll);

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('resize', handleScroll);
    };
  }, [thumbnails]);

  const scrollLeft = () => {
    const scrollContainer = scrollContainerRef_thumnailList.current;
    if (scrollContainer) {
      const newScrollLeft = scrollContainer.scrollLeft - 135;
      scrollContainer.scrollTo({
        left: Math.max(0, newScrollLeft),
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    const scrollContainer = scrollContainerRef_thumnailList.current;
    const { scrollWidth } = scrollContainer;
    if (scrollContainer) {
      const newScrollLeft = scrollContainer.scrollLeft + 135;
      scrollContainer.scrollTo({
        left: Math.min(newScrollLeft, scrollWidth + 1),
        behavior: 'smooth',
      });
    }
  };
  return (
    <div className={localStorage.getItem("deviceType") === 'mobile'?"h-[148px]":""}>
      {localStorage.getItem("deviceType") === 'mobile' && isLoaded && showLeftArrow && (
        <div className="absolute left-[1px] w-[40px] h-[140px] leading-[148px] cursor-pointer text-white text-center bg-black/[.7] h-full leading-[135px] z-50 left-[1px] top-[4px]"
          onClick={scrollLeft}>
          <LeftOutlined />
        </div>
      )}

      {/* <ScrollArea className="flex flex-col gap-[4px] pt-[4px] pr-[2.5px] pl-[5px] pb-[4px]"> */}
        <div
          ref={ref}
          className={localStorage.getItem("deviceType") === 'mobile'?"flex flex-col gap-[4px] pt-[4px] pr-[0px] pl-[0px] pb-[4px]":"flex flex-col gap-[4px] pt-[4px] pr-[2.5px] pl-[5px] pb-[4px]"}
        >
          {thumbnailItems.length > 0 && (
            <div
              id="ohif-thumbnail-list"
              ref={scrollContainerRef_thumnailList}
              className={
                thumbnailLocation === 'top' || localStorage.getItem("deviceType") === 'mobile'
                  ? 'ohif-scrollbar bg-bkg-low flex flex-row place-items-start gap-[4px] overflow-y-hidden'
                  : 'ohif-scrollbar bg-bkg-low grid grid-cols-[repeat(auto-fit,_minmax(0,135px))] place-items-start gap-[4px] overflow-y-hidden'
              }
            >
              {thumbnailItems.map(item => {
                const { displaySetInstanceUID, componentType, numInstances, ...rest } = item;

                const isActive = activeDisplaySetInstanceUIDs.includes(displaySetInstanceUID);
                return (
                  <Thumbnail
                    servicesManager={servicesManager}
                    key={displaySetInstanceUID}
                    {...rest}
                    displaySetInstanceUID={displaySetInstanceUID}
                    numInstances={numInstances || 1}
                    isActive={isActive}
                    thumbnailType={componentType}
                    viewPreset="thumbnails"
                    onClick={onThumbnailClick.bind(null, displaySetInstanceUID)}
                    onDoubleClick={onThumbnailDoubleClick.bind(null, displaySetInstanceUID)}
                    onClickUntrack={onClickUntrack.bind(null, displaySetInstanceUID)}
                    ThumbnailMenuItems={ThumbnailMenuItems}
                    onLoadComplete={onLoadComplete}
                  />
                );
              })}
            </div>
          )}
          {/* List Items */}
          {listItems.length > 0 && (
            <div
              id="ohif-thumbnail-list"
              className={
                thumbnailLocation === 'top'
                  ? 'ohif-scrollbar bg-bkg-low flex flex-row place-items-start gap-[4px] overflow-y-hidden'
                  : 'ohif-scrollbar bg-bkg-low grid grid-cols-[repeat(auto-fit,_minmax(0,135px))] place-items-start gap-[4px] overflow-y-hidden'
              }
            >
              {listItems.map(item => {
                const { displaySetInstanceUID, componentType, numInstances, ...rest } = item;
                const isActive = activeDisplaySetInstanceUIDs.includes(displaySetInstanceUID);
                return (
                  <Thumbnail
                    servicesManager={servicesManager}
                    key={displaySetInstanceUID}
                    {...rest}
                    displaySetInstanceUID={displaySetInstanceUID}
                    numInstances={numInstances || 1}
                    isActive={isActive}
                    thumbnailType={componentType}
                    viewPreset="list"
                    onClick={onThumbnailClick.bind(null, displaySetInstanceUID)}
                    onDoubleClick={onThumbnailDoubleClick.bind(null, displaySetInstanceUID)}
                    onClickUntrack={onClickUntrack.bind(null, displaySetInstanceUID)}
                    ThumbnailMenuItems={ThumbnailMenuItems}
                    onLoadComplete={onLoadComplete}
                  />
                );
              })}
            </div>
          )}
        </div>
      {/* </ScrollArea> */}
      {localStorage.getItem("deviceType") === 'mobile' && isLoaded && showRightArrow && (
        <div className="absolute w-[40px] h-[140px] leading-[148px] text-white text-center cursor-pointer bg-black/[.7] h-full leading-[135px] z-50 top-[4px] right-0"
          onClick={scrollRight}>
          <RightOutlined />
        </div>
      )}
    </div>
  );
};

ThumbnailList.propTypes = {
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      displaySetInstanceUID: PropTypes.string.isRequired,
      imageSrc: PropTypes.string,
      imageAltText: PropTypes.string,
      seriesDate: PropTypes.string,
      seriesNumber: PropTypes.any,
      numInstances: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      description: PropTypes.any,
      componentType: PropTypes.any,
      isTracked: PropTypes.bool,
      /**
       * Data the thumbnail should expose to a receiving drop target. Use a matching
       * `dragData.type` to identify which targets can receive this draggable item.
       * If this is not set, drag-n-drop will be disabled for this thumbnail.
       *
       * Ref: https://react-dnd.github.io/react-dnd/docs/api/use-drag#specification-object-members
       */
      dragData: PropTypes.shape({
        /** Must match the "type" a dropTarget expects */
        type: PropTypes.string.isRequired,
      }),
    })
  ),
  activeDisplaySetInstanceUIDs: PropTypes.arrayOf(PropTypes.string),
  onThumbnailClick: PropTypes.func.isRequired,
  onThumbnailDoubleClick: PropTypes.func.isRequired,
  onClickUntrack: PropTypes.func.isRequired,
  viewPreset: PropTypes.string,
  ThumbnailMenuItems: PropTypes.any,
};

export { ThumbnailList };
